import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import NoData from "../../NoData";
import Loading from "../../Loading";


export default function Board() {

    const [studyDetails, setStudyDetails] = useState({
        board: "",
        level: "",
        medium: [],
        status: 1,
        id: ""
    });

    const [languages, setLanguages] = useState([]);
    const [studyProfile, setStudyProfile] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [show, setShow] = useState(false);
    const adminToken = localStorage.getItem("authAdminToken");
    const [loading, setLoading] = useState(true);


    const handleClose = () => setShow(false);

    // Edit Section
    const handleEdit = async (event) => {
        event.preventDefault();

        if (!studyDetails.board) {
            toast.error("Board name field is required.");
            return;
        }
        if (!studyDetails.medium) {
            toast.info("Language field is required.");
            return;
        }
        if (!studyDetails.level) {
            toast.info("Level field is required.");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/setStudyProfile`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${adminToken}`
                },
                body: JSON.stringify(studyDetails),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("Study profile update successfully!");
                setShowForm(false);
            } else {
                toast.error("Failed to update study profile.");
            }

        } catch (error) {
            toast.error("Something went wrong! Please try again later.");
        }
    };

    // Study Profile View Section
    const fetchAllBoard = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getAllStudyProfile`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });
        return response.json();
    };


    // Fetch all languages
    const fetchAllLanguage = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getAllLanguage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });
        return response.json();
    };

    // Delete Section
    const handleDelete = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/deleteStudyProfile`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${adminToken}`
                },
                body: JSON.stringify({ id: studyDetails.id }),
            });
            const data = await response.json();

            if (data.status === true) {

                fetchAllBoard().then((res) => {
                    if (res.status) {
                        setStudyProfile(res?.studyProfile);
                    } else {
                        toast.error("Failed to load board. Please try again.");
                    }
                }).catch((error) => {
                    toast.error("Unable to fetch board at the moment.");
                });

                toast.success("Study profile delete successfully!");
                setShow(false);
            } else {
                toast.error("Failed to delete study profile.");
            }

        } catch (error) {
            toast.error("An error occurred while adding the study profile. Please try again later.");
        }
    };

    useEffect(() => {
        fetchAllBoard().then((res) => {
            if (res.status) {
                setStudyProfile(res?.studyProfile);

                fetchAllLanguage().then((res) => {
                    if (res.status) {
                        setLoading(false);
                        setLanguages(res?.languages);
                    } else {
                        toast.error("Failed to load languages. Please try again.");
                    }
                }).catch(() => {
                    toast.error("Unable to fetch languages at the moment.");
                });

            } else {
                toast.error("Failed to load board. Please try again.");
            }
        }).catch((err) => {
            toast.error("Unable to fetch board at the moment.");
        });



    }, [showForm]);

    function editStudyDetails(studyDetails) {
        setStudyDetails({ ...studyDetails, medium: JSON.parse(studyDetails.medium) });
        setShowForm(true);
    }

    function deleteStudyDetails(studyDetails) {
        setStudyDetails(studyDetails);
        setShow(true)
    }

    const inputDetails = useMemo(() => {
        return <div className="d-flex gap-2">
            {languages.length > 0 ? languages.map((langObj) => (
                <div key={langObj.id} className="form-check">
                    <input type="checkbox" className="form-check-input" id={langObj.id} checked={studyDetails.medium?.includes(langObj.language)}
                        onChange={(event) => {

                            if (event.target.checked) {
                                var details = JSON.parse(JSON.stringify(studyDetails));
                                details.medium.push(langObj.language)
                                setStudyDetails(details);
                            } else {
                                setStudyDetails({ ...studyDetails, medium: studyDetails.medium.filter((item) => item !== langObj.language) });
                            }
                        }} />

                    <label className="form-check-label fs-6" htmlFor={langObj.id}>
                        {langObj.language}
                    </label>
                </div>
            )) : null}
        </div>
    }, [studyDetails.medium, languages, studyDetails])

    return (
        <>
            {loading ?
                <Loading />
                :
                <>
                    {showForm ? (
                        <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 42em" }}>
                            <div className="app-ecommerce">
                                <div className="row">
                                    <div className="col-12 col-lg-8">
                                        <div className="card mb-6">
                                            <div className="card-header">
                                                <h5 className="card-tile mb-0">Edit Study Profile</h5>
                                            </div>
                                            <div className="card-body">

                                                <form onSubmit={(event) => { handleEdit(event) }}>
                                                    <div className="row gx-5 mb-5">
                                                        <div className="col">
                                                            <div className="form-floating form-floating-outline">
                                                                <input type="text" className="form-control" value={studyDetails.board} onChange={(e) => setStudyDetails({ ...studyDetails, board: e.target.value })} placeholder="Board Name" />
                                                                <label htmlFor="board">Board Name</label>
                                                            </div>
                                                        </div>

                                                        <div className="mb-5 col ecommerce-select2-dropdown d-flex justify-content-between align-items-center">
                                                            <div className="form-floating form-floating-outline w-100 me-4">
                                                                <select className="form-select form-select-sm" data-placeholder="Select Level" value={studyDetails.level}
                                                                    onChange={(e) => setStudyDetails({ ...studyDetails, level: e.target.value })} >
                                                                    <option value="">Select level</option>
                                                                    <option value="6-8">6-8</option>
                                                                    <option value="9-10">9-10</option>
                                                                    <option value="11-12">11-12</option>
                                                                </select>
                                                                <label htmlFor="level">Level</label>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="row gx-5 mb-1">
                                                        <div className="col">
                                                            <div className="form-floating form-floating-outline">
                                                                <select className="form-select form-select-sm" id="status" value={studyDetails.status} onChange={(event) => setStudyDetails({ ...studyDetails, status: parseInt(event.target.value) })}>
                                                                    <option value="">Select Status</option>
                                                                    <option value={1}>Active</option>
                                                                    <option value={0}>Inactive</option>
                                                                </select>
                                                                <label htmlFor="status">Status</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row gx-5 mb-5 mt-6" style={{ margin: "7px", padding: "7px" }}>
                                                        <div className="col">
                                                            <div className="form-floating form-floating-outline">
                                                                <label className="form-label d-block" htmlFor="medium" style={{ marginTop: "-3em" }}>Medium</label>
                                                                {inputDetails}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4 d-flex gap-4 mx-4">
                                                        <button type="submit" className="btn btn-primary">
                                                            Update
                                                        </button>
                                                        <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </form>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 25em" }}>
                            {/* Toast container */}
                            < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

                            <div className=" h-100 mh-200">
                                <div className="card-header border-bottom d-flex justify-content-between align-items-center pb-3">
                                    <h5 className="card-title mb-0">Study Profile</h5>
                                    <Link to="/admin/studyprofile">
                                        <button type="button" className="btn btn-primary">
                                            Add Study Profile
                                        </button>
                                    </Link>
                                </div>


                                {studyProfile.length > 0 ?
                                    <div className="row gy-4 gy-sm-1 my-3 mx-5">
                                        {studyProfile.map((boardName, idx) => {
                                            const boardMedium = JSON.parse(boardName.medium)
                                            return <div key={idx} className="card mt-5" style={{ width: "18rem", marginLeft: "20px" }}>
                                                <div className="card-body">
                                                    <div className="d-flex flex-row justify-content-between">
                                                        <div className="mt-3">{boardName.status ? <div className="text-success">Active</div> : <div className="text-danger">Inactive</div>}</div>

                                                        <div>
                                                            <button className="btn btn-icon" data-toggle="tooltip" data-placement="top" title="Edit" onClick={() => { editStudyDetails(boardName) }}>
                                                                <MdModeEdit style={{ color: "#666CFF" }} />
                                                            </button>

                                                            <button className="btn btn-icon mx-2" data-toggle="tooltip" data-placement="top" title="Delete" onClick={() => { deleteStudyDetails(boardName) }}>
                                                                <MdDelete style={{ color: "red" }} />
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="card-title d-flex flex-wrap align-items-center"><h6 className="m-0 me-2">Board Name:</h6> {boardName.board}</div>
                                                    <div className="card-title d-flex flex-wrap align-items-center"><h6 className="m-0 me-2">Level:</h6> {boardName.level}</div>

                                                    <div className="d-flex flex-column flex-md-row flex-wrap">
                                                        {boardMedium.map((lang, index) => (
                                                            <div key={index} className="mb-0 mx-1 mt-3" style={{ boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)", borderRadius: "7px", padding: "4px 17px" }}>{lang}</div>
                                                        ))}
                                                    </div>
                                                </div>

                                            </div>
                                        })}
                                    </div>
                                    :
                                    <NoData />
                                }

                            </div>
                        </div>
                    )}
                </>
            }

            {/* modal */}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Are you sure you want to delete this item?
                </Modal.Body>

                <div className="col-md-11 my-4 mx-5">
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-danger mt-3" onClick={handleDelete}>
                        Delete
                    </button>
                </div>
            </Modal>

        </>
    )
}
